<template>
    <div>
        <b-button
            id="btn-target-show-all-stages"
            class="mb-3 w-100"
            @click="isCollapseStages = !isCollapseStages"
            aria-controls="stages-details-collapse"
            :aria-expanded="isCollapseStages ? 'true' : 'false'"
            size="sm"
            :variant="isCollapseStages ? 'primary' : 'outline-primary'"
        >
            <span>{{ $t('stages.showAll') }}</span>
            <i
                :class="[
                    'fa',
                    'mt-1',
                    'float-right',
                    {
                        'fa-caret-up': isCollapseStages,
                        'fa-caret-down': !isCollapseStages,
                    },
                ]"
            ></i>
        </b-button>
        <b-collapse
            id="stages-details-collapse"
            v-model="isCollapseStages"
            class="mb-3"
        >
            <b-button-group id="stages" class="w-100" size="sm" vertical>
                <b-button
                    v-for="option in options"
                    :key="option.value"
                    :variant="
                        selectedStage == option.value && disabled
                            ? 'primary'
                            : 'outline-primary'
                    "
                    :id="`stage-${option.value}`"
                    :class="{
                        active: selectedStage == option.value,
                        disabled: disabled,
                    }"
                    @click="onClickStage(option.value, disabled)"
                    @mouseenter="onMouseEnterStage(option.value)"
                    @mouseleave="onMouseLeaveStage"
                >
                    {{ option.text }}
                </b-button>
            </b-button-group>
            <b-popover
                :key="stage.id"
                v-for="stage in data.all"
                :target="`stage-${stage.id}`"
                triggers="hover"
                placement="right"
                :show="isToShowPopoverOnStage === stage.id"
            >
                <template slot="title">
                    {{ stage.title }}
                </template>
                <p class="mb-2">
                    {{
                        $t('stages.periodOfStage', {
                            start: formatDate(stage.start_date),
                            end: formatDate(stage.end_date),
                        })
                    }}
                </p>
                <p class="mb-2" v-if="stage.description">
                    {{ stage.description }}
                </p>
                <ul class="pl-3" v-if="stage.event_has_criteria.length">
                    <li
                        :key="criterion.id"
                        v-for="criterion in stage.event_has_criteria"
                    >
                        {{
                            $t(
                                `stages.eventHasCriteria.${criterion.criterion.identifier}`
                            )
                        }}
                    </li>
                </ul>
            </b-popover>
        </b-collapse>
    </div>
</template>

<script>
import { getStringFromDateWithoutTime } from '@/lib/date'

export default {
    name: 'Template',
    data() {
        return {
            isCollapseStages: false,
            isToShowPopoverOnStage: null,
        }
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        selected: {},
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    created() {
        if (this.data.current && this.data.current.id) {
            this.selectedStage = this.data.current.id
        }
    },
    computed: {
        options() {
            return this.data.all.map((stage) => ({
                text: stage.title,
                value: stage.id,
            }))
        },
        selectedStage: {
            get() {
                return this.selected
            },
            set(selected) {
                this.$emit('update:selected', selected)
            },
        },
    },
    methods: {
        formatDate(string) {
            return getStringFromDateWithoutTime(string, 'YYYY-MM-DD')
        },
        onMouseEnterStage(id) {
            this.isToShowPopoverOnStage = id
        },
        onMouseLeaveStage() {
            this.isToShowPopoverOnStage = null
        },
        onClickStage(optionID, isDisabled) {
            if (!isDisabled) {
                this.$emit('onClickStage', optionID)
            }
        },
    },
}
</script>
